import React, { useEffect, useState } from "react";
import axios from "axios";
import CommonTextField from "components/common/CommonTextField";
import {
  ADD_NOTIFIED_USERS,
  GET_NOTIFIED_USERS,
  GET_USERS,
  REMOVE_NOTIFIED_USER,
} from "URLRoutes";
import { generateURLOptions } from "URLOptions";
import FoundUserItem from "../FoundUserItem";
import FilledButton from "components/InterstellrComponents/FilledButton";

const UpdateAdminUsersModal = ({ isOpen, onClose, item }) => {
  const [search, setSearch] = useState("");
  const [foundUsers, setFoundUsers] = useState([]);

  const [adminUsers, setAdminUsers] = useState([]);

  useEffect(() => {
    if (isOpen) {
      getAdminUsers();
    }
  }, [isOpen]);

  useEffect(() => {
    if (search.length > 0) {
      getUsers();
    } else {
      setFoundUsers([]);
    }
  }, [search]);

  const getAdminUsers = async () => {
    try {
      const response = await axios.get(GET_NOTIFIED_USERS, {
        headers: generateURLOptions(),
      });
      if (response?.data?.success === false) {
        alert(response?.data?.message ?? "");
        return;
      }

      console.log("Admin Users: ", response.data);
      setAdminUsers(response.data?.data);
    } catch (error) {
      console.error("Get Admin Users Error: ", error);
      alert(error);
    }
  };

  const getUsers = async () => {
    try {
      const response = await axios.get(
        GET_USERS + (search.length > 0 ? search : "all"),
        {
          headers: generateURLOptions(),
        }
      );
      if (response?.data?.success === false) {
        alert(response?.data?.message ?? "");
        return;
      }

      console.log("Users: ", response.data);
      setFoundUsers(response?.data?.data);
    } catch (error) {
      console.error("Get Users Error: ", error);
      alert(error);
    }
  };

  const addNotifiedUser = async (user) => {
    try {
      const response = await axios.post(
        ADD_NOTIFIED_USERS,
        {
          userId: user._id,
        },
        {
          headers: generateURLOptions(),
        }
      );

      if (response?.data?.success === false) {
        alert(response?.data?.message ?? "");
        return;
      }

      getAdminUsers();
      setSearch("");
    } catch (error) {
      console.error("Add User Error: ", error);
      alert(error);
    }
  };

  const removeNotifiedUser = async (user) => {
    try {
      const response = await axios.post(
        REMOVE_NOTIFIED_USER,
        {
          userId: user._id,
        },
        {
          headers: generateURLOptions(),
        }
      );

      if (response?.data?.success === false) {
        alert(response?.data?.message ?? "");
        return;
      }

      getAdminUsers();
      setSearch("");
    } catch (error) {
      console.error("Add User Error: ", error);
      alert(error);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
      <div className="bg-white rounded-2xl w-2/3 h-2/3 p-6 relative flex flex-col">
        <div className="grid grid-cols-2 gap-6">
          <div>
            {/* Header */}
            <div className="flex justify-between items-start mb-4">
              <div>
                <h2 className="text-lg font-semibold">Current Admin Users</h2>
                <p className="text-gray-500 text-sm">{item?.title ?? ""}</p>
              </div>
            </div>

            <div className="space-y-2">
              {adminUsers?.map((user) => (
                <FoundUserItem
                  key={user?._id}
                  item={user?.userId}
                  added={true}
                  onPress={removeNotifiedUser}
                />
              ))}
            </div>
          </div>

          <div className="space-y-6 relative">
            <CommonTextField
              label={"Search for User"}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder={"Search for Users"}
              marginBottom={0}
            />

            <div className="space-y-2 h-80 overflow-y-scroll">
              {foundUsers?.map((user) => (
                <FoundUserItem
                  key={user._id}
                  item={user}
                  onPress={addNotifiedUser}
                />
              ))}
            </div>
          </div>
        </div>
        <div style={{ flex: 1 }} />
        <div className="h-12 flex justify-between space-x-4">
          <FilledButton borderRadius={96} text={"Close"} onPress={onClose} />
        </div>
      </div>
    </div>
  );
};

export default UpdateAdminUsersModal;
